import { render } from "./PaymentConfirmation.vue?vue&type=template&id=ec90ca1e&scoped=true&lang=pug"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=ts"

import "./PaymentConfirmation.vue?vue&type=style&index=0&id=ec90ca1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ec90ca1e"

export default script